module.exports = __webpack_public_path__ + "img/member_center_footer431006.423c08e1.png";